<script>
	import { website } from '../content/configuration.gen';
	import ThemeController from '$lib/components/ThemeController.svelte';
	import Icon from '@iconify/svelte';
	import { theme } from '../stores/theme';
	import Logo from '../components/Logo.svelte';
</script>

<div class="min-h-screen grid grid-cols-1 grid-rows-[4rem_auto]">
	<header class="h-16 navbar justify-between">
		<Logo {website} />
		<!-- TODO remove -->
		<!-- <a href="/" class="btn btn-ghost btn-sm flex items-center gap-2">
			{#if website.metadata.logo.length}
				<img src={website.metadata.logo} alt={website.name} class="my-0 h-8" />
			{:else}
				<span class="hidden sm:block">{website.name}</span>
			{/if}
		</a> -->

		<button
			type="button"
			class="ml-auto hidden sm:block btn btn-circle btn-ghost btn-sm"
			on:click={theme.toggle}
		>
			<span class="sr-only">Toggle Theme</span>
			<ThemeController />
		</button>

		<div class="flex items-center justify-between gap-4 px-4">
			<a
				href={website.header.secondary.href}
				target="_blank"
				rel="noopener noreferrer"
				class="hidden sm:inline-block link link-hover hover:link-primary focus:link-primary"
			>
				{website.header.secondary.label}
			</a>
			<a
				href={website.header.primary.href}
				target="_blank"
				rel="noopener noreferrer"
				class="btn btn-primary btn-sm"
			>
				{website.header.primary.label}
				<Icon icon="charm:chevron-right" width="16" height="16" />
			</a>
		</div>
	</header>

	<main class="pt-10 px-3 container mx-auto">
		<div class="prose">
			<slot />
		</div>
	</main>
</div>
